<template>
  <div>
    {{ $t(`${tKey}.texts.mainMessage`) }}
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { UserModule, UserStateAuthType } from '@/store/modules/user'
import { toasts } from '@/utils/toasts'
import i18n from '@/lang'

@Component({
  name: 'Logout'
})
export default class extends Vue {
  get tKey(): string {
    return 'view.logout'
  }

  get tToasts(): string {
    return `${this.tKey}.toasts`
  }

  async created(): Promise<void> {
    if (UserModule.authenticationType === UserStateAuthType.Windows) {
      return
    }

    const wasLoggedOut = await UserModule.logout()
    if (wasLoggedOut) {
      toasts.success(i18n.t(`${this.tToasts}.byeMessage`) as string, {
        title: i18n.t(`${this.tToasts}.byeTitle`) as string
      })
      await this.$router.replace({ path: '/login' })
    } else {
      toasts.error(i18n.t(`${this.tToasts}.byeErrorMessage`) as string, {
        title: i18n.t(`${this.tToasts}.byeErrorTitle`) as string
      })
      await this.$router.go(-1)
      // await UserModule.checkAndSetAuthStatus()
    }
  }
}
</script>
